import { render } from "./container-history-page.vue?vue&type=template&id=4071d91e&scoped=true"
import script from "./container-history-page.vue?vue&type=script&lang=js"
export * from "./container-history-page.vue?vue&type=script&lang=js"

import "./container-history-page.vue?vue&type=style&index=0&id=4071d91e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4071d91e"]])

export default __exports__